import { render, staticRenderFns } from "./SocialMediaReloginButton.vue?vue&type=template&id=4309c88c&"
import script from "./SocialMediaReloginButton.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaReloginButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports